<template>
  <SiteHeader />
  <router-view />
  <SiteFooter />
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  color: var(--ink);
}
</style>
